import * as Flags from "../../lib/Flags";

import insightRoutes from "../../views/InsightsIndex/routes.json";
import { StoreState } from "../RootReducer";
import { createSelector } from "../../lib/util/ReduxUtils";
import { MenuItem } from "../../components/nav/MenuDropdown/MenuDropdown";

export const selectInsights = (state: StoreState) => state.Insights.insights;

export const selectActiveInsightCount = (state: StoreState) => {
	const insights = selectInsights(state);
	return (
		(Flags.FRESH_VIEW.is()
			? insights.value?.length
			: insights.value?.filter((i) => !i.archived && !i.read).length) || 0
	);
};

export const getArchivedInsightCount = createSelector(
	[selectInsights],
	(insights) => insights.value?.filter((i) => i.archived).length || 0,
);

export const selectFilterSelection = (state: StoreState) =>
	state.Insights.filterSelection;
export const selectNavigationSelection = (state: StoreState) =>
	state.Insights.navigationSelection;

export const selectVisibleInsights = createSelector(
	[selectInsights, selectFilterSelection, selectNavigationSelection],
	(insights, filterSelection, navigationSelection) => {
		if (!insights.value) return [];

		const insightData = insights.value

			// filter the archived if selected
			.filter((insight) => {
				if (navigationSelection === "archived") {
					return insight.archived;
				} else {
					return !insight.archived;
				}
			})

			// filter the insights selected by CATEGORIES
			.filter((insight) => {
				// eslint-disable-line
				return (
					filterSelection.category.toLowerCase() === "all" ||
					insight.typeId.toLowerCase() ===
						filterSelection.category.toLowerCase()
				);
			});

		return insightData;
	},
);

// TODO: find a better home for this
export const selectRouteFromHash = (
	hash: string | null,
): MenuItem | undefined => {
	if (!hash) return undefined;
	return insightRoutes.find((route) => route.pathName === `#${hash}`);
};
